<template>
  <div v-show="showComponent">
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:elevator_plural') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headerSet="isAdmin ? headers : []"
          :headers="isAdmin ? [] : headers"
          icon="edit"
          icon2="tune"
          :icon3="isAdmin ? 'trending_up' : 'play_circle'"
          :icon4="isAdmin ? 'settings_power' : 'photo_camera'"
          :dependsOnProperty3="isAdmin ? null : 'viewPlaylist'"
          :dependsOnProperty4="isAdmin ? null : 'liftImage'"
          @clickedButton1="editElevator"
          :iconTooltip="$t('buttons:edit')"
          @clickedButton2="editButtonContent"
          :iconTooltip2="$t('display/elevator:overview.edit-button-content')"
          @clickedButton3="button3Clicked"
          :iconTooltip3="isAdmin ? $t('display/elevator:overview.offline-statistic') : $t('display/elevator:overview.playlist-view.view-playlist')"
          @clickedButton4="button4Clicked"
          :iconTooltip4="isAdmin ? $t('display/elevator:overview.control-panel') : $t('display/elevator:overview.open-lift-photo')"
          @updateTableData="updateTable"
          @clickedAddButton="editElevator"
          @updateHeaders="updateHeaders"
          :customPanel="createPanel()"
          :expand="true"
          :expandFn="expandField"
          :trueFalseDecorateFields="decorateFields"
          :addBtn="isAdmin"
          :addBtnText="$t('buttons:add-specific', { specific: $t('common:elevator')})"
          image="thumbnailPath"
          imageAlt="building_thumbnail.png"
          sortBy="name"
          :filterName="isAdmin ? 'elevator' : null"
          @filterStatusChanged="filterStatusChange"
          @cacheCommit="$store.commit('display/elevator/storeElevatorOverviewSearch', $event)"
          :add-top-scroll-bar="isAdmin"
        />
      </v-col>
    </v-row>

    <ElevatorForm
      ref="elevatorForm"
      @updateTable="callUpdate"
    />

    <PlaylistView
      ref="playlistView" />

    <ButtonContentForm
      ref="buttonContentForm"
    />

    <SnapImage
      ref="snapImage" />

    <OfflineStats
      ref="offlineStats" />

    <ElevatorFunctionsForm
      ref="elevatorFunctions"
      @updateTable="callUpdate"/>

    <TwoButtonDialog
      ref="updatePlaylist"
      :outlined="true"
      :rounded="false"
      :hideButton="true"
      color="primary"
      :dialog-title="$t('display/elevator:overview.custom-panel.update-playlists')"
      :dialog-text="$t('display/elevator:overview.custom-panel.update-text-playlists')"
      :button1-text="$t('buttons:cancel')"
      :button2-text="$t('display/elevator:edit.dialog.send')"
      @clickedButton1="$refs.updatePlaylist.showDialog = false"
      @clickedButton2="makeUpdatePlaylist()"
    />

  </div>
</template>

<script>
import {Role} from '@/modules/core/data/roles';
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import ElevatorService from '@/modules/display/services/elevator-service';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import TablePanel from '@/modules/display/views/elevator/overview/TablePanel';
import Elevator from '@/modules/display/data/elevator';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import ElevatorForm from '@/modules/display/views/elevator/ElevatorForm';
import ButtonContentForm from '@/modules/display/views/elevator/ButtonContentForm';
import UsersService from '@/modules/core/services/users-service';
import ExpandedField from '@/modules/display/views/elevator/overview/ExpandedField';
import ElevatorHeader from '@/modules/display/views/elevator/overview/elevator-header';
import InfoService from '@/modules/core/services/info-service';
import PlaylistView from '@/modules/display/views/elevator/overview/PlaylistView';
import Vue from 'vue';
import {i18n} from '@/plugins/i18next';
import OfflineStats from '@/modules/display/views/elevator/OfflineStats';
import SnapImage from "@/modules/display/views/elevator/overview/SnapImage";
import ElevatorFunctionsForm from "@/modules/display/views/elevator/ElevatorFunctionsForm";

export default {
  name: "ElevatorOverview",
  components: {
    SnapImage,
    OfflineStats,
    DataTablePaginated,
    ElevatorForm,
    ButtonContentForm,
    TwoButtonDialog,
    PlaylistView,
    ElevatorFunctionsForm
  },
  data() {
    return {
      headersSelected: [],
      showComponent: false,
      userHeaders: [],
      headerClass: new ElevatorHeader(),
      countries: new Map(),
      languageIsChanging: false,
      isFilterOpen: false
    };
  },
  computed: {
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    decorateFields() {
      return this.isAdmin ? ['io', 'active', 'motion', 'online', 'playlist', 'camera', 'isEmergencySetUp'] : [];
    },
    headers() {
      let header = [];
      this.$t('');
      if (this.isAdmin) {
        header = this.headerClass.getHeader();
      } else {
        header = this.headerClass.getUserHeader();
      }

      if (this.isAdmin && this.isSavedHeadersValid(this.userHeaders)) {
        for (let i = 0; i < header.length; i++) {
          header[i].default = this.userHeaders.indexOf(header[i].value) >= 0;
        }
      }

      return header;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  watch: {
    overviewSearch(value) {
      if (this.cardView) {
        this.$refs.table.search = value;
      }
    },
    currentLang() {
      this.languageIsChanging = true;
      Utils.sleep(500).then(() => {
        this.callUpdate();
      });
    }
  },
  methods: {
    callUpdate() {
      this.$refs.table.callTableUpdate();
    },
    editElevator(elevatorItem) {
      this.$refs.elevatorForm.initialization(elevatorItem);
    },
    editElevatorById(elevatorId) {
      this.$refs.elevatorForm.initializationById(elevatorId);
    },
    editButtonContent(elevatorItem) {
      this.$refs.buttonContentForm.initialization(elevatorItem);
    },
    button3Clicked(elevatorItem) {
      if (this.isAdmin) {
        this.openOfflineLog(elevatorItem);
      } else {
        this.openPlaylist(elevatorItem);
      }
    },
    button4Clicked(elevatorItem) {
      if(this.isAdmin) {
        this.openFunctions(elevatorItem);
      }
      else {
        this.openLiftPhoto(elevatorItem);
      }
    },
    openOfflineLog(elevatorItem) {
      this.$refs.offlineStats.initialization(elevatorItem);
    },
    openLiftPhoto(elevatorItem) {
      this.$refs.snapImage.initialization(elevatorItem);
    },
    openPlaylist(elevatorItem) {
      this.$refs.playlistView.initialization(elevatorItem.id);
    },
    openFunctions(elevatorItem){
      this.$refs.elevatorFunctions.initialization(elevatorItem.id);
    },
    updateTable(options, search, filter) {
      if (!search) search = '';

      this.$refs.table.loading = true;

      if (options.sortBy[0]) {
        // there is no translatedCountry field in the DB but country
        options.sortBy[0] = options.sortBy[0] === 'translatedCountry' ? 'country' : options.sortBy[0];
      }

      if (typeof filter === 'undefined') {
        this.searchTableUpdate(options, search);
      } else {
        this.filterTableUpdate(options, search, filter);
      }
    },
    setIsEmergencySet(elevatorList) {
      for (let i = 0; i < elevatorList.length; i++) {
        elevatorList[i].isEmergencySetUp = typeof elevatorList[i].emergencyCenter === 'string'
            && elevatorList[i].emergencyCenter.length > 0
            && typeof elevatorList[i].emergencyPhoneNumber === 'string'
            && elevatorList[i].emergencyPhoneNumber.length > 0;
      }
      return elevatorList;
    },
    searchTableUpdate(options, search) {
      ElevatorService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (options.sortBy[0]) {
            // reverse replace
            options.sortBy[0] = options.sortBy[0] === 'country' ? 'translatedCountry' : options.sortBy[0];
          }
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Elevator);
            if (this.isAdmin && response.data.content.length > 0) {
              this.setIsEmergencySet(response.data.content);
              for (let i = 0; i < response.data.content.length; i++) {
                response.data.content[i].translatedCountry =
                    Utils.translateCountry(this.countries.get(response.data.content[i].country));
              }
            } else if (!this.isAdmin && response.data.content.length > 0) {
              for (let i = 0; i < response.data.content.length; i++) {
                response.data.content[i].liftImage = this.eligibleShowImage(response.data.content[i]);
                response.data.content[i].viewPlaylist = this.eligibleShowPlaylist(response.data.content[i]);
              }
            }
            this.$refs.table.fillTableData(response.data);
          }
          this.languageIsChanging = false;
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:elevator_plural')}));
          this.$logger.error(error);
        }
      );
    },
    eligibleShowImage(elevator) {
      let options = elevator.options;
      if (!options || options.length < 0) {
        return false;
      }

      let eligibleShowImage = false;
      for (let i = 0; i < options.length; i++) {
        if (options[i].name === 'SNAP ELEVATOR IMAGE COUNTER') {
          eligibleShowImage = true;
          break;
        }
      }

      return eligibleShowImage;
    },
    eligibleShowPlaylist(elevator) {
      let options = elevator.options;
      if (!options || options.length < 0) {
        return false;
      }

      let eligibleShowPlaylist = false;
      for (let i = 0; i < options.length; i++) {
        if (options[i].name === 'VIEW PLAYLIST') {
          eligibleShowPlaylist = true;
          break;
        }
      }

      return eligibleShowPlaylist;
    },
    filterTableUpdate(options, search, origFilter) {
      ElevatorService.readFilterPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        this.isFilterOpen ? '' : search,
        options.sortBy,
        options.sortDesc,
          this.isFilterOpen ? ElevatorService.updateFilterForSend(origFilter) : {},
        (response) => {
          if (options.sortBy[0]) {
            // reverse replace
            options.sortBy[0] = options.sortBy[0] === 'country' ? 'translatedCountry' : options.sortBy[0];
          }
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Elevator);
            if (response.data.content.length > 0) {
              this.setIsEmergencySet(response.data.content);
              for (let i = 0; i < response.data.content.length; i++) {
                let currentCountry = this.countries.get(response.data.content[i].country);
                if (!currentCountry) {
                  response.data.content[i].translatedCountry = '';
                } else {
                  response.data.content[i].translatedCountry =
                      Utils.translateCountry(currentCountry);
                }
              }
            }
            this.$refs.table.fillTableData(response.data);
            this.languageIsChanging = false;
          }
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:elevator_plural')}));
          this.$logger.error(error);
        }
      )
    },
    isSavedHeadersValid(headers) {
      if (!Array.isArray(headers)) {
        return false;
      }

      if (headers.length <= 0) {
        return false;
      }

      for (let i = 0; i < headers.length; i++) {
        if (typeof headers[i] === 'string'
          && headers[i].length > 0
          && !this.isNumeric(headers[i])) {
          return true;
        }
      }

      return false;
    },
    isNumeric(str) {
      if (typeof str != "string") return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    updateHeaders(headers) {
      if (this.showComponent === true && !this.languageIsChanging) {
        UsersService.saveElevatorHeader({columns: headers});
      }
    },
    expandField(item) {
      let ExpandedFieldComponent = Vue.extend(ExpandedField);
      return new ExpandedFieldComponent({
        i18n,
        propsData: {
          item: item
        }
      })
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: {isAdmin: this.isAdmin}
      });

      instance.$on('updatePlaylist', this.updatePlaylist);
      instance.$on('reloadTable', this.callUpdate);
      return instance;
    },
    updatePlaylist() {
      this.$refs.updatePlaylist.showDialog=true;
    },
    makeUpdatePlaylist() {
      ElevatorService.updatePlaylist(
        () => {
          Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
        },
        () => {
          Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
        }
      );
      this.$refs.updatePlaylist.showDialog = false;
    },
    updateFilter() {
      this.$refs.table.rerenderFilterPanel();
      this.callUpdate();
    },
    loadCountries() {
      InfoService.readOptionsByUrl(
        'country',
        (response) => {
         let countries = Utils.translateAllCountries(response);
         countries.forEach(
           (country) => {
             this.countries.set(country.id, country.name);
           }
         )
        }
      )
    },
    filterStatusChange(status) {
      this.isFilterOpen = status;
      this.updateFilter();
    }
  },
  created() {
    if (this.isAdmin) {
      this.loadCountries();
      UsersService.getElevatorHeader(
          (response) => {
            this.userHeaders = response.data;
            this.showComponent = true;
          }
      )
    } else {
      this.showComponent = true;
    }
  },
  mounted() {
    if (this.$route.query.resourceId) {
      this.$refs.table.search = this.$route.query.resourceId;
    }
    setTimeout(() => {
      if (this.$route.query.total === null) {
        this.$refs.table.setFilterValue('test', 2);
        this.$refs.table.setFilterValue('demo', 2);
        this.updateFilter();
      } else if (this.$route.query.active === null) {
        this.$refs.table.setFilterValue('test', 2);
        this.$refs.table.setFilterValue('demo', 2);
        this.$refs.table.setFilterValue('active', 1);
        this.updateFilter();
      } else if (this.$route.query.deactivated === null) {
        this.$refs.table.setFilterValue('test', 2);
        this.$refs.table.setFilterValue('demo', 2);
        this.$refs.table.setFilterValue('active', 2);
        this.updateFilter();
      } else if(this.$route.query.offline === null) {
        this.$refs.table.setFilterValue('test', 2);
        this.$refs.table.setFilterValue('demo', 2);
        this.$refs.table.setFilterValue('active', 1);
        this.updateFilter();
      } else if(this.$route.query.elevatorId) {
        //load elevator via id
        ElevatorService.readFromAPI(
            this.$route.query.elevatorId,
            (response) => {
              this.editElevator(response.data);
            },
            (error) => {
              this.$logger.error("Failed loading facility with id " + this.$route.query.elevatorId +", because: " + error);
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:elevator')}));
            })
      }
    }, 50);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(to.query.elevator) {
        vm.editElevatorById(to.query.elevator)
        vm.$router.replace(`/${vm.$store.state.manager.displayModuleUrl}/elevator`);
      }
    });
  },
}
</script>

<style scoped>

</style>
